// extracted by mini-css-extract-plugin
export default {"button":"yl-z","reviewSort":"zl-z"};